export const iconFontAwesomePunctuationSymbolsAsterisk = (
	<i className="fa-solid fa-asterisk"></i>
);
